import React, { createContext, useState, useEffect } from 'react';
import axios from '../helpers/axiosConfig';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);

  const [authState, setAuthState] = useState({
    isAuthenticated: false,
    user: null,
  });
  const [redirectUrl, setRedirectUrl] = useState(null);

  // Vérification de l'authentification
  const checkAuth = async () => {
    const token = localStorage.getItem("accessToken");

    if (!token) {
      setAuthState({ isAuthenticated: false, user: null });
      setLoading(false);
      return;
    }

    try {
      const response = await axios.get("/auth/checkToken", {
        headers: { Authorization: `Bearer ${token}` },
      });

      if (response.data.isAuthenticated) {
        setAuthState({
          isAuthenticated: true,
          user: response.data.user,
        });
      } else {
        localStorage.removeItem("accessToken");
        setAuthState({ isAuthenticated: false, user: null });
      }

    } catch (error) {
      localStorage.removeItem("accessToken");
      setAuthState({ isAuthenticated: false, user: null });
    }

    setLoading(false);
  };

  /*  const checkAuth = async () => {
     const token = localStorage.getItem('accessToken');
 
     if (!token) {
       setAuthState({ isAuthenticated: false, user: null });
       setLoading(false);
       return;
     }
 
     try {
       const response = await axios.get('/auth/checkToken', {
         withCredentials: true,
         headers: { Authorization: `Bearer ${token}` },
       });
       if (response.data.isAuthenticated) {
         setAuthState({
           isAuthenticated: true,
           user: response.data.user,
         });
       } else {
         localStorage.removeItem('accessToken');
         setAuthState({ isAuthenticated: false, user: null });
 
         if (window.location.pathname !== '/login') {
           setRedirectUrl(window.location.pathname); // Enregistre l'URL pour redirection
         }
         navigate('/login');
       }
     } catch (error) {
       localStorage.removeItem('accessToken');
       setAuthState({ isAuthenticated: false, user: null });
       navigate('/login');
     }
   }; */
  // Redirection après authentification
  useEffect(() => {
    //&& redirectUrl
    if (authState.isAuthenticated) {
      console.log('authState.isAuthenticated : ', authState);
      navigate(redirectUrl);
      setRedirectUrl(null); // Réinitialise l'URL de redirection
    }
  }, [authState.isAuthenticated, redirectUrl, navigate]);

  const login = async (username, password) => {
    try {
      const response = await axios.post('/auth/login', { username, password });
      const data = response.data;


      if (data.accessToken) {
        localStorage.setItem('accessToken', data.accessToken);
        setAuthState({
          isAuthenticated: true,
          user: data.user,
        });

        navigate(redirectUrl || '/');
        setRedirectUrl(null);
      } else {
        toast.error('Erreur de connexion');
      }
    } catch (error) {
      toast.error(error.response?.data?.error || 'Erreur lors de la connexion');
    }
  };

  // Vérification de l'authentification lors du chargement
  useEffect(() => {
    checkAuth();
    console.log("authState : ", authState);
  }, []);

  // Fonction de déconnexion
  const handleLogout = () => {
    localStorage.removeItem('accessToken');
    setAuthState({
      isAuthenticated: false,
      user: null,
    });
    navigate('/login');
  };

  return <AuthContext.Provider value={{ authState, login, handleLogout, loading, setRedirectUrl }}>{children}</AuthContext.Provider>;
};
